export enum DeleteDeviceActionTypes {
  DELETE_DEVICE_REQUEST = 'DELETE_DEVICE_REQUEST',
  DELETE_DEVICE_SUCCEEDED = 'DELETE_DEVICE_SUCCEEDED',
  DELETE_DEVICE_FAILED = 'DELETE_DEVICE_FAILED',
}

export interface DeleteDeviceRequest {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST;
  input: object;
}

export interface DeleteDeviceSucceeded {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_SUCCEEDED;
  statusMessage: string;
}

export interface DeleteDeviceFailed {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_FAILED;
  error: string;
}

export type DeleteDeviceActions = DeleteDeviceRequest | DeleteDeviceSucceeded | DeleteDeviceFailed;

export function deleteDeviceRequest(input): DeleteDeviceRequest {
  return {
    type: DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST,
    input,
  };
}

export function deleteDeviceSucceeded(statusMessage: string): DeleteDeviceSucceeded {
  return {
    type: DeleteDeviceActionTypes.DELETE_DEVICE_SUCCEEDED,
    statusMessage,
  };
}

export function deleteDeviceFailed(error: string): DeleteDeviceFailed {
  return {
    type: DeleteDeviceActionTypes.DELETE_DEVICE_FAILED,
    error,
  };
}
